module.exports = __webpack_public_path__ + "img/drop_point.ddd2d81.svg";